import { DSSpacer, DSText, DSTextAndIcon } from '@zoe/ds-web'
import { LegalPageRecord } from './LegalPage'
import { useRouter } from 'next/router'

type LegalPagePageHeaderProps = {
  page: LegalPageRecord
  hideArchives?: boolean
}

export const LegalPagePageHeader = ({ page, hideArchives }: LegalPagePageHeaderProps) => {
  const router = useRouter()
  const pathSegments = router.asPath.split('/').filter(Boolean)
  const basePath = pathSegments.length === 1 ? pathSegments : pathSegments.slice(0, -1).join('/')

  return (
    <>
      <DSSpacer size={48} direction="vertical" />

      <DSText as="h2" variant="fluid-paragraph-400" weight="regular">
        {page.pageName}
      </DSText>
      <DSSpacer size={24} direction="vertical" />

      <DSText as="h1" variant="fluid-heading-600">
        {page.pageTitle}
      </DSText>

      <DSSpacer size={24} direction="vertical" />

      <DSText as="p" variant="fluid-paragraph-300" weight="regular">
        Effective: {page.effectiveFrom}
      </DSText>

      <DSSpacer size={24} direction="vertical" />

      {!hideArchives && (
        <>
          <a href={`/${basePath}/archives${page.country ? `?country=${page.country}` : ''}`}>
            <DSTextAndIcon
              icon={{
                name: 'arrow-right',
                size: 16,
                color: 'link',
                position: 'right',
              }}
              variant="fluid-paragraph-200"
              color="link"
              weight="semiBold"
            >
              Archived versions
            </DSTextAndIcon>
          </a>
          <DSSpacer size={24} direction="vertical" />
        </>
      )}
    </>
  )
}
